import { render, staticRenderFns } from "./CourseWisePurchaseTa.vue?vue&type=template&id=52e00d80&"
import script from "./CourseWisePurchaseTa.vue?vue&type=script&lang=js&"
export * from "./CourseWisePurchaseTa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VFlex,VIcon,VLayout,VSimpleTable})
